<template>
  <div class="about">
    <input id="Json" type="text" v-model="SelectedAssortiment" />
    <input id="Product" type="text" v-model="SelectedCollection" />
    <input id="Product" type="text" v-model="SelectedProduct" />
    <button @mouseup="getProductData()">Get</button>
  </div>
  <div class="d-flex column">
    <div class="me-5">
      <p>Nederlands</p>
      <pre>{{ productText.nl }}</pre>
    </div>
    <div>
      <p>Engels</p>
      <pre>{{ productText.en }}</pre>
    </div>
  </div>
</template>

<script>
import json from "@/scripts/json.js";

export default {
  data() {
    return {
      SelectedAssortiment: "vinyl",
      SelectedCollection: "safe-tex",
      SelectedProduct: "Safe Tex R11",
      productText: {
        nl: "",
        en: "",
      },
    };
  },
  computed: {},
  methods: {
    getProductData() {
      this.productText.nl = json.displayProductData(
        this.SelectedAssortiment,
        this.SelectedCollection,
        this.SelectedProduct,
        "nl-NL"
      );
      this.productText.en = json.displayProductData(
        this.SelectedAssortiment,
        this.SelectedCollection,
        this.SelectedProduct,
        "en-EN"
      );
    },
    // end methods
  },
};
</script>
